// extracted by mini-css-extract-plugin
export default {"billModal":"M02Oxcph","ant-modal-content":"ant-modal-content","container":"UGBGdabm","inner":"XXSHfXV8","paragraph":"RnefYZtq","largeText":"auu_rnbS","button":"S7BsEgH8"};